import { render, staticRenderFns } from "./SummaryConfiguration.vue?vue&type=template&id=3137b0f3&scoped=true&"
import script from "./SummaryConfiguration.vue?vue&type=script&lang=js&"
export * from "./SummaryConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./SummaryConfiguration.vue?vue&type=style&index=0&id=3137b0f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3137b0f3",
  null
  
)

export default component.exports